// removed by extract-text-webpack-plugin
module.exports = {"page":"LeyvV5F2z _30W7J4cYZ _18QA6WPGs _2SpyW05bO gkmejKHip","title":"_3-iC12N2t _1yJuXbiru _2NhPjnbc3 _1yThnDgzj _1BE2U7F8v ODSLv4a7K _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j _1C-lRJLgc _1gaUFCwDT","paragraph":"_2ZJgOO3pf _1C-lRJLgc xBrMYP3IH _2F0aAUJAA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/styleguide/styleguide.css
 ** module id = 2196
 ** module chunks = 0
 **/